export default {
  cameras: 'Cameras',
  cancel: 'Cancel',
  enter_preset_name: 'Enter preset name',
  general_layouts: 'General layouts',
  save_preset: 'Save preset',
  save: 'Save',
  saved_presets: 'Saved presets'
};
